import { render, staticRenderFns } from "./newSkiLandTC.vue?vue&type=template&id=2cb27f6e&scoped=true&"
import script from "./newSkiLandTC.vue?vue&type=script&lang=js&"
export * from "./newSkiLandTC.vue?vue&type=script&lang=js&"
import style0 from "./newSkiLandTC.vue?vue&type=style&index=0&id=2cb27f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb27f6e",
  null
  
)

export default component.exports